import React from "react";
import { useLocation } from "react-router-dom";
import { ChevronRight, Menu } from "lucide-react";
import { findActiveNav } from "navigation/navConfig";
import AccountMenu from "./AccountMenu";

const TopBar = ({ sections, user, onOpenNav }) => {
  const { pathname } = useLocation();
  const active = findActiveNav(sections, pathname);
  const current = pathname === "/support" ? "Support" : pathname === "/profile" ? "Your profile" : active?.item.label;

  return (
    <header className="cc-topbar cc-bb">
      <button type="button" className="cc-icon-btn cc-topbar__menu" onClick={onOpenNav} aria-label="Open menu">
        <Menu size={20} />
      </button>

      <div className="cc-crumbs">
        {active?.section.title && (
          <>
            <span className="cc-crumbs__section">{active.section.title}</span>
            <ChevronRight size={14} className="cc-crumbs__sep" aria-hidden="true" />
          </>
        )}
        {current && <span className="cc-crumbs__current">{current}</span>}
      </div>

      <AccountMenu user={user} />
    </header>
  );
};

export default TopBar;
